import { mapActions } from "vuex";
import { verifyPlan, runVerifyLoop } from "@/utils/cvcMigrationPage";

// Verify target for the sections that run it outside Section B (after Activate,
// and "Verify this AVC" in the reconnection table): sequential calls of a few
// AVCs each, with a progress bar instead of the page-wide loader. Use inside
// `run()` of the section-actions mixin; the component needs the props
// `preflight`, `cvcId` and `targetHostId`. A rollback verifies the source router with
// the same call: pass `host` ({ id, name }) and the answer is returned, not handed to the
// page (the page keeps the target's last verify).
export default {
  data: () => ({
    verifying: false,
    verifyProgress: null,
  }),
  computed: {
    verifyProgressText () {
      const p = this.verifyProgress;
      if (!p) return "";
      const what = p.first > 0 ? `AVCs ${p.first}-${p.last}` : "CVC and loop subinterfaces";
      return `Verifying ${p.index}/${p.total} (${what})`;
    },
  },
  methods: {
    ...mapActions("cvcMigration", ["cvcMigrationVerifyTargetChunk"]),
    // `onlyIds` narrows it to chosen AVCs; the page merges such a partial answer
    // into the last full one.
    async verifyRun (onlyIds, host) {
      const router = host || { id: this.targetHostId, name: this.preflight.targetHostname };
      this.verifying = true;
      try {
        const out = await runVerifyLoop({
          plan: verifyPlan(this.preflight.rows, this.preflight.verifyMaxAvcs, onlyIds),
          callChunk: avcIds => this.cvcMigrationVerifyTargetChunk({
            cvcId: this.cvcId,
            targetHostId: router.id,
            avcIds,
          }),
          targetHostname: router.name,
          onProgress: p => { this.verifyProgress = p; },
        });
        if (out.results.length && !host) this.$emit("verified", { merged: out.merged, partial: !!onlyIds });
        if (out.stoppedBy === "busy") this.alert = { type: "warning", text: out.message };
        if (out.stoppedBy === "refused") this.alert = { type: "warning", text: out.message };
        if (out.stoppedBy === "error") this.alert = { type: "error", text: out.message };
        return out;
      } finally {
        this.verifying = false;
        this.verifyProgress = null;
      }
    },
  },
};
